import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {IEtapeScenario} from '../../_models/EtapeScenario';
import {BaseHubService} from './base-hub.service';
import {MessageService} from '../local/message.service';
import {ConfigService} from '../local/config.service';
import {IBaseObject} from '../../_models/BaseObject';
import {Store} from '@ngrx/store';
import {MainStoreState} from '../../_store/mainStoreState';
import {
  setEtapesScenariosSuccessAction,
} from '../../_store/EtapeStore/etape.store';

@Injectable({
  providedIn: 'root',
})
export class EtapeService extends BaseHubService<IEtapeScenario> {
  constructor(
    http: HttpClient,
    messageService: MessageService,
    configService: ConfigService,
    private store: Store<MainStoreState>
  ) {
    super(
      'scenarios-preprogrammes/etapes',
      'hubs/spEtapeHub',
      'Etapes',
      http,
      messageService,
      configService
    );
  }

  refreshHubConnection(): Promise<void> {
    return this.start();
  }

  protected dispatchUpdateData(data: IBaseObject[]): void {
    this.store.dispatch(
      setEtapesScenariosSuccessAction({payload: data as IEtapeScenario[]})
    );
  }
}
